<template>
  <div>
    <v-dialog v-model="isAdding" title="Add a new crypto rate" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Add a new Crypto Currency</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <create-crypto-form @created="currencyCreated" />
        </v-container>
      </v-card>
    </v-dialog>
    <data-table
      :headers="headers"
      url="/api/v1/cryptoCurrencies"
      title="Crypto Currencies"
      item-key="id"
      ref="table"
      searchable
    >
      <v-btn slot="action.icons" color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Currency
      </v-btn>
      <template slot="item.icon" slot-scope="{ item }">
        <currency-icon :currency="item" />
      </template>
    </data-table>
  </div>
</template>
<script>
import CreateCryptoForm from "./cryptoForm";
import CurrencyIcon from "./icon";
export default {
  components: { CreateCryptoForm, CurrencyIcon },
  data() {
    return {
      isAdding: false,
      headers: {
        icon: "Icon",
        name: "Name",
        short_name: "Short Name",
        address_format: "Address Format",
      },
    };
  },
  methods: {
    currencyCreated() {
      this.isAdding = false;
      this.$refs.table.fetchData();
      window.Notify.success("Crypto currency was created successfully");
    },
  },
};
</script>
